
import { Component } from '@angular/core';

import {LanguageService} from './../../services/LanguageService';
import {LanguageConstants} from './../../common/language/LanguageConstants';

@Component({
    selector: 'error-component',
    templateUrl: './ErrorComponent.html',
})

export class ErrorComponent
{

    public language = 'en';
    public languageConstants = LanguageConstants['en'];

    ngOnInit()
    {
    }

    goBack() {
        (<any>window).history.back();
    }

    constructor(private _language: LanguageService) {
        this._language.language$.subscribe
            (language =>
            {
                  this.language = language;
                  this.languageConstants = LanguageConstants[this.language];
            });
    }

}
